import { render, staticRenderFns } from "./SearchOnlyTags.vue?vue&type=template&id=3cfdb6cf&scoped=true"
import script from "./SearchOnlyTags.vue?vue&type=script&lang=js"
export * from "./SearchOnlyTags.vue?vue&type=script&lang=js"
import style0 from "./SearchOnlyTags.vue?vue&type=style&index=0&id=3cfdb6cf&prod&scoped=true&lang=css"
import style1 from "./SearchOnlyTags.vue?vue&type=style&index=1&id=3cfdb6cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfdb6cf",
  null
  
)

export default component.exports